import { ProductBasic } from './product.model';
import { DeviceBasic } from '../device-models/device-basic-model/device-basic.model';
import { CenterLite } from '../center-model/center-lite.model';
import { CatalogDesk } from './catalog-desk.model';

export class CatalogBasic {
    private active: boolean;
    private image: string;
    private internalId: string;
    private description: string;
    private backgroundColor: string;
    private textColor: string;
    private ordering: number;
    private centers: CenterLite[];
    private desks: CatalogDesk[];
    private devicesMCatalog: DeviceBasic[];
    private devicesStaff: DeviceBasic[];
    private products: ProductBasic[];
    private printInmediately: boolean;

    constructor(active?: boolean, image?: string, internalId?: string, description?: string, backgroundColor?: string, textColor?: string, ordering?: number, centers?: CenterLite[], desks?: CatalogDesk[], devicesMCatalog?: DeviceBasic[], devicesStaff?: DeviceBasic[], products?: ProductBasic[], printInmediately?: boolean) {
        this.active = active;
        this.image = image;
        this.internalId = internalId;
        this.description = description;
        this.backgroundColor = backgroundColor;
        this.textColor = textColor;
        this.ordering = ordering;
        this.centers = centers;
        this.desks = desks;
        this.devicesMCatalog = devicesMCatalog;
        this.devicesStaff = devicesStaff;
        this.products = products;
        this.printInmediately = printInmediately;
    }

    public get Active(): boolean {
        return this.active;
    }
    public get Image(): string {
        return this.image;
    }
    public get InternalId(): string {
        return this.internalId;
    }
    public get Description(): string {
        return this.description;
    }
    public get BackgroundColor(): string {
        return this.backgroundColor;
    }
    public get TextColor(): string {
        return this.textColor;
    }
    public get Ordering(): number {
        return this.ordering;
    }
    public get Centers(): CenterLite[] {
        return this.centers;
    }
    public get Desks(): CatalogDesk[] {
        return this.desks;
    }
    public get DevicesMCatalog(): DeviceBasic[] {
        return this.devicesMCatalog;
    }
    public get DevicesStaff(): DeviceBasic[] {
        return this.devicesStaff;
    }
    public get Products(): ProductBasic[] {
        return this.products;
    }
    public get PrintInmediately(): boolean {
        return this.printInmediately;
    }
    public set Active(active: boolean) {
        this.active = active;
    }
    public set Image(image: string) {
        this.image = image;
    }
    public set InternalId(internalId: string) {
        this.internalId = internalId;
    }
    public set Description(description: string) {
        this.description = description;
    }
    public set BackgroundColor(backgroundColor: string) {
        this.backgroundColor = backgroundColor;
    }
    public set TextColor(textColor: string) {
        this.textColor = textColor;
    }
    public set Ordering(ordering: number) {
        this.ordering = ordering;
    }
    public set Centers(centers: CenterLite[]) {
        this.centers = centers;
    }
    public set Desks(desks: CatalogDesk[]) {
        this.desks = desks;
    }
    public set DevicesMCatalog(devicesMCatalog: DeviceBasic[]) {
        this.devicesMCatalog = devicesMCatalog;
    }
    public set DevicesStaff(devicesStaff: DeviceBasic[]) {
        this.devicesStaff = devicesStaff;
    }
    public set Products(products: ProductBasic[]) {
        this.products = products;
    }
    public set PrintInmediately(printInmediately: boolean) {
        this.printInmediately = printInmediately;
    }
}
